let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j37FZ")).then(() => parcelRequire('az2Jc'));